import {Fragment} from 'react'
import PropTypes from 'prop-types'

import ErrorIcon from '@mui/icons-material/Error'

import {ContentBox} from '../../../../dashboard/src/components/blocks/ContentBoxes'
import {ModalHeader} from '../../../../shared_components/core/modals/ModalHeaders'
import {Remove} from '../../../../dashboard/src/components/blocks/Buttons'
import {Text} from '../../../../dashboard/src/components/blocks/Texts'

const ManageTfaSetupFrame = props => (
  <Fragment>
    <ContentBox className='header-with-icon flex-container'>
      <ContentBox className='icon-container flex-container'>
        {props.headerIcon}
      </ContentBox>
      <ModalHeader heading={props.headerTitle} subheading={props.headerSubtitle} />
    </ContentBox>
    {props.children}
    {
      props.removeText && (
        <ContentBox className='footer'>
          <Remove onClick={props.primaryAction} processing={props.loading}>{props.removeText}</Remove>
          {
            props.warningText && (
              <Text className='warning flex-container'>
                <ErrorIcon fontSize='small' /> <span>{props.warningText}</span>
              </Text>
            )
          }
        </ContentBox>
      )
    }
  </Fragment>
)

ManageTfaSetupFrame.propTypes = {
  headerIcon: PropTypes.node.isRequired,
  headerTitle: PropTypes.string.isRequired,
  headerSubtitle: PropTypes.string.isRequired,
  removeText: PropTypes.string,
  warningText: PropTypes.string,
  primaryAction: PropTypes.func
}

export default ManageTfaSetupFrame
